import _ from "lodash";

/**
 * This function checks whether element which has focus is an input or a textarea field.
 * It is mainly used in keyboard events to differentiate between typing in input field and keyboard shortcuts.
 */
function isTypingInInput() {
  if (!document.activeElement) return false;

  switch (document.activeElement.tagName) {
    case "TEXTAREA": {
      return true;
    }
    case "INPUT": {
      /**
       * WHy this condition?
       * Generally, input fields have the purpose of filling forms, or provide support for
       * entering text. But, radio buttons are also used to create focusable lists, where each list item
       * can be traversed using arrow keys. This pattern is used in DS components such as SegmentControl, Tabs etc.
       * So, when user is interacting with radio buttons, we will consider that user is not interacting with input field.
       *
       * Downside of this approach is that when user is selecting a radio input, he/she can use keyboard shortcuts at the same time.
       */
      return !_.includes(["radio", "checkbox"], document.activeElement.type);
    }

    default: {
      /**
       * This is needed for editable DOM elements using contentEditable attribute.
       * contentEditable = "true": The element is editable with rich text formatting.
       * contentEditable = "plaintext-only": The element is editable, but only plain text is allowed.
       */
      return _.includes(
        ["true", "plaintext-only"],
        document.activeElement.contentEditable
      );
    }
  }
}

export default isTypingInInput;
